module.exports = __webpack_public_path__ + "static/media/desktop-04.880fe417.png";